// @flow
import React, { Component } from 'react'
import VkPublics from './VkPublics'
import FacebookPublics from './FacebookPublics'
import styled, { type StyledComponent } from 'styled-components'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 60%;
  padding-bottom: 25px;

  @media screen and (max-width: 700px) {
    width: 80%;
  }
`

type Props = {|
  vkProps: {
    isTokenPresent: boolean,
    isTokenDeactivated: boolean,
    updatePublicsPath: string,
    updateTokenPath: string,
    publics: Array<Object>
  },
  facebookProps: {
    isTokenPresent: boolean,
    isTokenDeactivated: boolean,
    updatePublicsPath: string,
    updateTokenPath: string,
    publics: Array<Object>
  }
|}

type State = {|
  isLocked: boolean
|}

export default class ProviderPublics extends Component<Props, State> {
  state = {
    isLocked: false
  }

  lock() {
    this.setState({ isLocked: true })
  }

  unlock() {
    this.setState({ isLocked: false })
  }

  render() {
    return (
      <Wrapper>
        <VkPublics
          onAjaxStarted={() => {
            this.lock()
          }}
          onAjaxFinished={() => {
            this.unlock()
          }}
          isLocked={this.state.isLocked}
          {...(this.props.vkProps: Object)}
        />
        <FacebookPublics
          onAjaxStarted={() => {
            this.lock()
          }}
          onAjaxFinished={() => {
            this.unlock()
          }}
          isLocked={this.state.isLocked}
          {...(this.props.facebookProps: Object)}
        />
      </Wrapper>
    )
  }
}
